<template>
  <div class="bg-menu">
    <div class="container">
      <b-row>
        <b-col lg="8" md="9">
          <div class="middel d-inline-block pl-1">
            <span>تماس:</span>
            <a class="link-contact pl-3" v-for="(tel_phone, index) in findAttributeOnSiteInfo('tel_phone')"
               :key="index" :href="`tel:${tel_phone}`">
              {{ tel_phone }}
            </a>
            <a class="link-contact  " v-for="(cell_phone, index) in findAttributeOnSiteInfo('cell_phone')"
               :key="index" :href="`tel:${cell_phone}`">
              {{ cell_phone }}
            </a>
          </div>

          <div class="social">

            <span>ما را دنبال کنید:</span>

            <a v-if="findAttributeOnSiteInfo('social_media_twitter')"
               v-for="twitter in findAttributeOnSiteInfo('social_media_twitter')" :href="twitter">
              <b-icon icon="twitter" class="icon"></b-icon>
            </a>

            <a v-if="findAttributeOnSiteInfo('social_media_whatsapp')"
               v-for="whatsapp in findAttributeOnSiteInfo('social_media_whatsapp')"
               :href="`https://wa.me/${whatsapp}`">
              <svg class="icon" xmlns="http://www.w3.org/2000/svg" color="black" width="16" height="16"
                   fill="#fff" viewBox="0 0 16 16">
                <path
                    d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
              </svg>
            </a>

            <a v-if="findAttributeOnSiteInfo('social_media_instagram')"
               v-for="instagram in findAttributeOnSiteInfo('social_media_instagram')" :href="instagram">
              <b-icon icon="instagram" class="icon"></b-icon>
            </a>

            <a v-if="findAttributeOnSiteInfo('social_media_linkedin')"
               v-for="linkedin in findAttributeOnSiteInfo('social_media_linkedin')" :href="linkedin">
              <b-icon icon="linkedin" class="icon"></b-icon>
            </a>


          </div>


        </b-col>


        <b-col lg="4" md="3">
          <div class=" text-center pt-2">

            <m-a class="text-white pl-3 " :href="{ name: 'Login' }">
              <b-icon icon="box-arrow-in-right" class="text-white custom-font-size-for-icon"></b-icon>
              ورود
            </m-a>

            <m-a class="text-white" :href="{ name: 'Register' }">
              <b-icon icon="receipt" class="text-white custom-font-size-for-icon"></b-icon>
              ثبت نام
            </m-a>


          </div>
        </b-col>

      </b-row>
    </div>


  </div>

</template>


<script>
export default {
  name: 'Nav800'
}
</script>


<style scoped>
.bg-menu {
  background-color: var(--light-red);
  color: var(--light-white);
}

.link-contact {
  color: var(--light-white);
  text-decoration: none;
}

.social {
  display: inline-block;
  margin-right: 20px;
  margin-left: 0;
  border-right: 1px solid #fff;
  border-left: 0;
  padding: 10px 20px 10px 0;

}

.icon {
  color: aliceblue;
  margin-right: 10px
}

.custom-font-size-for-icon {
  font-size: 20px
}

@media only screen and (max-width: 535px) {
  .social {
    border-right: none;
    text-align: center;

  }
}

@media only screen and (max-width: 535px) {
  .bg-menu {
    text-align: center;
  }
}
</style>